import { tEnum } from "@components/i18n";
import { CamelCaseKeys } from "@utils/typescript";
import { UserLess } from "./User";

export enum DocumentTypes {
  Insurance = 'insurance',
  Customer = 'customer',
}

export type Document = CamelCaseKeys<{
  id: number;
  document_type: DocumentTypes;
  created_at: number;
  name: string;
  document: string;
  creator: UserLess;
}>;

export const tDocumentType = (type: DocumentTypes) => tEnum('documentTypes', type);
